import AsyncStorage from "@react-native-async-storage/async-storage";
import { StorageProviderContextType } from "../../types";
import { errorReporting } from "./errorReporting";

export const Storage: StorageProviderContextType = {
  getItem: async (key) => {
    return AsyncStorage.getItem(key).catch((error) => {
      errorReporting.sendMessage(`Storage.getItem failed for key: ${key}`, {
        error: error?.message,
      });
      return null;
    });
  },
  setItem: async (key, value) => {
    try {
      await AsyncStorage.setItem(key, value);
      return true;
    } catch (error) {
      errorReporting.sendMessage(`Storage.setItem failed for key: ${key}`, {
        error: error instanceof Error ? error.message : String(error),
      });
      return false;
    }
  },
  clear: async () => {
    try {
      await AsyncStorage.clear();
      return true;
    } catch (error) {
      errorReporting.sendMessage("Storage.clear failed", {
        error: error instanceof Error ? error.message : String(error),
      });
      return false;
    }
  },
};
